<template>
  <v-card
    class="mx-auto"
    :style="{ 'width': isSimulation ? '375px' : `${sizeW}px`}"
    style="border-radius: 0 !important"
  >
    <v-card
      dark
      flat
      v-if="data.TimelineDate"
    >
      <v-img
        v-if="!data.HideHeader"
        :src="data.TimelineImage ? data.TimelineImage : 'https://cdn.vuetifyjs.com/images/cards/forest.jpg'"
        gradient="to top, rgba(0,0,0,.44), rgba(0,0,0,.44)"
        :style="{ 'height': !isSimulation && isDesktop ? '300px !important' : 'auto'}"
      >
        <v-container
          v-if="data.IsHeaderText"
          class="fill-height"
        >
          <v-row align="left" style="padding-left: 20px">
            <div class="headline font-weight-light" style="margin-right: 20px;text-transform:capitalize;">
              <span style="font-size: 30px;">{{textHeader}}</span>
              <br v-if="subtextHeader.length > 0">
              <span style="font-size: 20px;" v-if="subtextHeader.length > 0">{{subtextHeader.toUpperCase()}}</span>
            </div>
            <!-- <div class="text-uppercase font-weight-light">{{month}} {{year}}</div> -->
          </v-row>
        </v-container>
        <v-container
          v-else
          class="fill-height"
        >
          <v-row align="center" style="padding-left: 20px">
            <strong class="display-4 font-weight-regular mr-6">{{dayOfMonth}}</strong>
          </v-row>
          <v-row justify="left">
            <div class="headline font-weight-light" style="margin-right: 20px;text-transform:capitalize;">
              <span style="font-size: 30px;">{{dayOfWeek}}</span>
              <br>
              <span style="font-size: 20px;">{{month.toUpperCase()}} {{year}}</span>
            </div>
            <!-- <div class="text-uppercase font-weight-light">{{month}} {{year}}</div> -->
          </v-row>
        </v-container>
      </v-img>
    </v-card>
    <v-card-text class="py-0">
      <v-timeline
        align-top
        dense
        style="margin-left:-10%;width:110%;"
      >
        <timeline-item
          v-for="(time, index) in data.Times"
          :key="`mnu${index}`"
          :time="time"
        />
      </v-timeline>
    </v-card-text>
  </v-card>
</template>

 <script>
  import constants from '@/constants'
  import TimelineItem from './timelineItem'
  import utils from '@/services/utils'
  export default {
    components: {
      TimelineItem
    },
    props: {
      data: {
        type: Object,
        required: true,
        default: null
      },
    },
    computed: {
      locale () {
        return this.$store.state.app.locale;
      },
      isSimulation () {
        return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      isDesktop () {
        return !utils.isMobile()
      },
      date () {
        return new Date(this.data.TimelineDate)
      },
      dayOfMonth () {
        return this.date.getDate()
      },
      dayOfWeek () {
        return this.date.toLocaleString(this.locale, {  weekday: 'long' })
      },
      month () {
        return this.date.toLocaleString(this.locale, {  month: 'long' })
      },
      year () {
        return this.date.getFullYear()
      },
      sizeW () {
        return window.innerWidth - (!utils.isMobile() ? 360 : 0)
      },
      textHeader () {
        return utils.getTranslation (this.data.TimeLineTextHeader, this.locale)
      },
      subtextHeader () {
        return utils.getTranslation (this.data.TimeLineSubTextHeader, this.locale)
      }
    }
  }
</script>
